import React from 'react'
import { Page } from '../../Elements/PageMargins'
import { NotificationFormCard } from './NotificationFormCard'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { notificationApi } from '../../../api/swagger'
import { useNotificationContext } from '../../Context/NotificationContext'
import {
  SnackbarSeverity,
  useSnackbarContext,
} from '../../Context/SnackbarContext'
import { useAppSnackbar } from '../../../hooks/useAppSnackbar'

export const AddNotification: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    notificationDetails,
    updateSelectedNotificationKey,
    updateNotificationDetails,
  } = useNotificationContext()

  const { setSnackbarMessage, setSnackbarSeverity, setSnackbarState } =
    useSnackbarContext()
  const { handleError } = useAppSnackbar()

  const handleFormSubmit = async () => {
    try {
      const { notification } = await notificationApi.createNotification({
        body: {
          notification: notificationDetails,
        },
      })

      /** We know it's a number */
      updateSelectedNotificationKey(notification.notificationKey as number)
      updateNotificationDetails(notification)

      setSnackbarMessage(
        t(
          'Notifications.AddNotification.CreateNotification.Success',
          'The notification was successfully created.'
        )
      )
      setSnackbarSeverity(SnackbarSeverity.Success)
      setSnackbarState(true)

      navigate(
        `/admin/notifications/notification-details/${notification.notificationKey}`,
        {}
      )
    } catch (e) {
      handleError(
        e,
        t(
          'Notifications.AddNotification.EditNotification.DefaultError',
          'An unknown error occurred while creating the notification.'
        )
      )
    }
  }

  return (
    <Page>
      <Box maxWidth={1200}>
        <NotificationFormCard
          isEditVariant={false}
          handleFormSubmit={handleFormSubmit}
        />
      </Box>
    </Page>
  )
}
